export const ADMIN_API_PATH = '/api/v1/admin'

const RESOURCE_ORIGIN = 'https://mia-admin-route.invalid'
const encodedPathSeparator = /%(2f|5c)/i
const controlCharacter = /[\u0000-\u001f\u007f]/

function normalizePathname(pathname: string) {
  const trimmed = pathname.replace(/\/{2,}/g, '/').replace(/\/+$/, '')
  return trimmed === '' ? '/' : trimmed
}

function validateProtocol(url: URL, value: string) {
  if (!['http:', 'https:'].includes(url.protocol)) {
    throw new Error(`A URL administrativa deve usar HTTP ou HTTPS. Valor recebido: ${value}`)
  }
  if (!url.hostname || url.username || url.password) {
    throw new Error(`A URL administrativa possui autoridade inválida. Valor recebido: ${value}`)
  }
}

export function normalizeAdminApiBaseUrl(value: string) {
  const normalizedValue = value.trim()
  const url = new URL(normalizedValue)
  validateProtocol(url, normalizedValue)
  const pathname = normalizePathname(url.pathname)

  if (pathname === '/') {
    url.pathname = ADMIN_API_PATH
  } else if (pathname !== ADMIN_API_PATH) {
    throw new Error(`A URL administrativa deve terminar em ${ADMIN_API_PATH}. Valor recebido: ${value}`)
  } else {
    url.pathname = ADMIN_API_PATH
  }

  url.search = ''
  url.hash = ''
  return url.toString().replace(/\/+$/, '')
}

export function normalizeAdminResourcePath(value: string) {
  const normalizedValue = value.trim()
  if (!normalizedValue.startsWith('/') || normalizedValue.startsWith('//')) {
    throw new Error(`O caminho da API deve iniciar com uma única barra. Valor recebido: ${value}`)
  }
  if (controlCharacter.test(normalizedValue) || normalizedValue.includes('\\') || encodedPathSeparator.test(normalizedValue)) {
    throw new Error(`O caminho da API contém caracteres inválidos. Valor recebido: ${value}`)
  }
  if (normalizedValue.includes('#')) {
    throw new Error(`O caminho da API não pode conter fragmento. Valor recebido: ${value}`)
  }
  const rawPath = normalizedValue.split('?', 1)[0] ?? ''
  if (rawPath.split('/').some((part) => part === '.' || part === '..')) {
    throw new Error(`O caminho da API não pode conter navegação relativa. Valor recebido: ${value}`)
  }
  const resource = new URL(normalizedValue, RESOURCE_ORIGIN)
  if (resource.origin !== RESOURCE_ORIGIN) {
    throw new Error(`O caminho da API não pode definir outra origem. Valor recebido: ${value}`)
  }
  const pathname = normalizePathname(resource.pathname)
  if (pathname === ADMIN_API_PATH || pathname.startsWith(`${ADMIN_API_PATH}/`)) {
    throw new Error(`O caminho do recurso não deve repetir ${ADMIN_API_PATH}`)
  }
  return `${pathname}${resource.search}`
}

export function buildAdminApiUrl(baseUrl: string, resourcePath: string) {
  const base = new URL(normalizeAdminApiBaseUrl(baseUrl))
  const normalizedResourcePath = normalizeAdminResourcePath(resourcePath)
  const resource = new URL(normalizedResourcePath, RESOURCE_ORIGIN)
  base.pathname = resource.pathname === '/' ? ADMIN_API_PATH : `${ADMIN_API_PATH}${resource.pathname}`
  base.search = resource.search
  base.hash = ''
  return base.toString().replace(/\/$/, '')
}
